module.exports = __webpack_public_path__ + "static/img/nav14.387a5261.svg";